import React from "react";
import { useState, useEffect } from "react";
import { format } from "date-fns";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import ConfirmDialog from "../components/ConfirmDialog";
import LoadingOverlay from "./LoadingOverlay";

const listTitle = [
  { value: 1, text: "Mr" },
  { value: 2, text: "Ms" },
];

const inp =
  "w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-white focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-200 transition";
const inpDisabled =
  "w-full border border-gray-200 rounded-lg px-3 py-2 text-sm bg-gray-100 text-gray-400 cursor-not-allowed";
const lbl =
  "block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1";
const sectionHead =
  "text-xs font-bold uppercase tracking-widest text-blue-600 border-b border-blue-100 pb-1.5 mb-3";

const UpdateQuotationModal = ({ dataSet, onClose, refreshData }) => {
  const { user } = useSelector((state) => state.auth);

  const [refNo, setRefNo] = useState("");
  const [quoteDesc, setQuoteDesc] = useState("");
  const [quotePn, setQuotePn] = useState("");
  const [quoteSize, setQuoteSize] = useState("");
  const [quoteMaterial, setQuoteMaterial] = useState("");
  const [quotePrinting, setQuotePrinting] = useState("");
  const [quotePrice1, setQuotePrice1] = useState("");
  const [quotePrice2, setQuotePrice2] = useState(" ");
  const [quotePrice3, setQuotePrice3] = useState(" ");
  const [quotePrice4, setQuotePrice4] = useState(" ");
  const [quotePrice5, setQuotePrice5] = useState(" ");
  const [quoteMpn, setQuoteMpn] = useState(" ");
  const [quoteCurrency, setQuoteCurrency] = useState("IDR");
  const [quoteLt, setQuoteLt] = useState("1 weeks");
  const [quoteCxl, setQuoteCxl] = useState("NCNR");
  const [quoteResch, setQuoteResch] = useState("NCNR");
  const [quoteDelTerm, setQuoteDelTerm] = useState("FOB BATAM");
  const [quotePayTerm, setQuotePayTerm] = useState("30 Days");
  const [quoteEffType, setQuoteEffType] = useState("PO BASED");
  const [quoteExpDate, setQuoteExpDate] = useState(
    "3 months after the date of quotation",
  );
  const [quoteOrigin, setQuoteOrigin] = useState("Indonesia");
  const [attn, setAttn] = useState("");
  const [title, setTitle] = useState("");
  const [selectedClientId, setSelectedClientId] = useState("");
  const [inputDateSelected, setInputDateSelected] = useState(new Date());
  const [axiosClientValue, setAxiosClientValue] = useState("");
  const [axiosClientLabel, setAxiosClientLabel] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadPending, setUploadPending] = useState(false);

  useEffect(() => {
    if (dataSet) {
      const fullName = dataSet.attn;
      const nameArray = fullName.split(" ");
      const t = nameArray[0];
      const lastName = nameArray.slice(1).join(" ");
      setTitle(t === "Mr" ? "Mr" : t === "Ms" ? "Ms" : 0);
      setRefNo(dataSet.quote_id);
      setInputDateSelected(new Date(dataSet.quote_date));
      setAttn(lastName);
      setQuoteDesc(dataSet.descr);
      setQuotePn(dataSet.pn);
      setQuoteSize(dataSet.size);
      setQuoteMaterial(dataSet.mat);
      setQuotePrinting(dataSet.clr);
      setQuotePrice1(dataSet.price1);
      setQuotePrice2(dataSet.price2);
      setQuotePrice3(dataSet.price3);
      setQuotePrice4(dataSet.price4);
      setQuotePrice5(dataSet.price5);
      setQuoteMpn(dataSet.mpn);
      setQuoteCurrency(dataSet.curr);
      setQuoteLt(dataSet.lead);
      setQuotePayTerm(dataSet.term);
      setQuoteEffType(dataSet.effect_type);
      setQuoteOrigin(dataSet.coo);
      setAxiosClientLabel(dataSet.nme);
      setAxiosClientValue(dataSet.cust_id);
      setSelectedClientId(dataSet.cust_id);
    }
  }, [dataSet]);

  const updateQuotation = async () => {
    setIsLoading(true);
    try {
      await axios.patch(`https://eps.elkomprintama.com/patch/api/quotation`, {
        cust_id: selectedClientId,
        quote_date: format(inputDateSelected, "yyyy-MM-dd"),
        attn: title + " " + attn,
        descr: quoteDesc,
        pn: quotePn,
        size: quoteSize,
        mat: quoteMaterial,
        clr: quotePrinting,
        price1: quotePrice1,
        price2: quotePrice2,
        price3: quotePrice3,
        price4: quotePrice4,
        price5: quotePrice5,
        curr: quoteCurrency,
        lead: quoteLt,
        term: quotePayTerm,
        effect_type: quoteEffType,
        mpn: quoteMpn,
        coo: quoteOrigin,
        admin: user.username,
        quote_id: refNo,
      });
      toast.success("Quotation updated successfully.");
      onClose();
      refreshData();
    } catch (error) {
      toast.error("Update failed. Please try again.");
    } finally {
      setIsLoading(false);
      setUploadPending(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      title === 0 ||
      !attn ||
      !quoteDesc ||
      !quotePn ||
      !quoteSize ||
      !quoteMaterial ||
      !quotePrinting ||
      !quotePrice1
    ) {
      toast.error("Please fill in all required fields.");
      return;
    }
    setUploadPending(true);
    setShowConfirm(true);
  };

  return (
    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl flex flex-col max-h-[90vh]">
      {/* Modal header */}
      <div className="flex items-center justify-between px-6 py-4 bg-blue-600 rounded-t-2xl flex-shrink-0">
        <div>
          <h2 className="text-white font-bold text-base leading-tight">
            Edit Quotation
          </h2>
          <span className="text-blue-200 text-xs font-mono">{refNo}</span>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="text-white hover:text-blue-200 text-2xl font-bold leading-none transition"
        >
          ✕
        </button>
      </div>

      {/* Scrollable form body */}
      <form
        onSubmit={handleSubmit}
        className="flex flex-col flex-1 overflow-hidden"
      >
        <div className="overflow-y-auto flex-1 px-6 py-5 space-y-6">
          {/* Section 1: Quotation Details */}
          <section>
            <p className={sectionHead}>Quotation Details</p>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className={lbl}>Quotation Number</label>
                <input
                  className={inpDisabled}
                  value={refNo}
                  disabled
                  readOnly
                />
              </div>
              <div>
                <label className={lbl}>Date</label>
                <DatePicker
                  className={inp}
                  wrapperClassName="w-full"
                  selected={inputDateSelected}
                  onChange={setInputDateSelected}
                  dateFormat="dd/MM/yyyy"
                />
              </div>
            </div>
            <div className="mt-4">
              <label className={lbl}>
                Customer{" "}
                <span className="ml-1 text-gray-400 normal-case font-normal">
                  (locked)
                </span>
              </label>
              <input
                className={inpDisabled}
                value={axiosClientLabel}
                disabled
                readOnly
              />
            </div>
            <div className="grid grid-cols-4 gap-4 mt-4">
              <div>
                <label className={lbl}>Title</label>
                <select
                  className={inp}
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                >
                  <option value={0}>Select</option>
                  {listTitle.map((t) => (
                    <option key={t.value} value={t.text}>
                      {t.text}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-span-3">
                <label className={lbl}>
                  Attention <span className="text-red-400">*</span>
                </label>
                <input
                  className={inp}
                  name="attn" type="text"
                  placeholder="Contact name"
                  value={attn}
                  onChange={(e) => setAttn(e.target.value)}
                />
              </div>
            </div>
          </section>

          {/* Section 2: Item Description */}
          <section>
            <p className={sectionHead}>Item Description</p>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className={lbl}>
                  Description <span className="text-red-400">*</span>
                </label>
                <input
                  className={inp}
                  name="quotedesc" type="text"
                  placeholder="Description"
                  value={quoteDesc}
                  onChange={(e) => setQuoteDesc(e.target.value)}
                />
              </div>
              <div>
                <label className={lbl}>
                  Part Number <span className="text-red-400">*</span>
                </label>
                <input
                  className={inp}
                  name="quotepn" type="text"
                  placeholder="Part number"
                  value={quotePn}
                  onChange={(e) => setQuotePn(e.target.value)}
                />
              </div>
              <div>
                <label className={lbl}>
                  Size <span className="text-red-400">*</span>
                </label>
                <input
                  className={inp}
                  name="quotesize" type="text"
                  placeholder="Size"
                  value={quoteSize}
                  onChange={(e) => setQuoteSize(e.target.value)}
                />
              </div>
              <div>
                <label className={lbl}>
                  Material <span className="text-red-400">*</span>
                </label>
                <input
                  className={inp}
                  name="quotematerial" type="text"
                  placeholder="Material"
                  value={quoteMaterial}
                  onChange={(e) => setQuoteMaterial(e.target.value)}
                />
              </div>
              <div>
                <label className={lbl}>
                  Printing / Colour <span className="text-red-400">*</span>
                </label>
                <input
                  className={inp}
                  name="quoteprinting" type="text"
                  placeholder="Printing / colour"
                  value={quotePrinting}
                  onChange={(e) => setQuotePrinting(e.target.value)}
                />
              </div>
            </div>
          </section>

          {/* Section 3: Pricing */}
          <section>
            <p className={sectionHead}>Pricing</p>
            <p className="text-xs text-gray-400 mb-3">
              Double-click a label to reset its field to the default template.
            </p>
            <div className="grid grid-cols-2 gap-4">
              {[
                {
                  label: "Pricing 1",
                  val: quotePrice1,
                  set: setQuotePrice1,
                  required: true,
                },
                { label: "Pricing 2", val: quotePrice2, set: setQuotePrice2 },
                { label: "Pricing 3", val: quotePrice3, set: setQuotePrice3 },
                { label: "Pricing 4", val: quotePrice4, set: setQuotePrice4 },
                { label: "Pricing 5", val: quotePrice5, set: setQuotePrice5 },
              ].map(({ label, val, set, required }) => (
                <div key={label}>
                  <label
                    className={`${lbl} cursor-pointer select-none`}
                    onDoubleClick={() => set("QTY.................@Rp")}
                    title="Double-click to reset"
                  >
                    {label}{" "}
                    {required && <span className="text-red-400">*</span>}
                  </label>
                  <input
                    className={inp}
                    name="val" type="text"
                    placeholder={label}
                    value={val}
                    onChange={(e) => set(e.target.value)}
                  />
                </div>
              ))}
            </div>
          </section>

          {/* Section 4: Terms */}
          <section>
            <p className={sectionHead}>Terms & Conditions</p>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className={lbl}>Currency</label>
                <input
                  className={inp}
                  name="quotecurrency" type="text"
                  placeholder="e.g. IDR"
                  value={quoteCurrency}
                  onChange={(e) => setQuoteCurrency(e.target.value)}
                />
              </div>
              <div>
                <label className={lbl}>MPN (Optional)</label>
                <input
                  className={inp}
                  name="quotempn" type="text"
                  placeholder="MPN"
                  value={quoteMpn}
                  onChange={(e) => setQuoteMpn(e.target.value)}
                />
              </div>
              <div>
                <label className={lbl}>Lead Time</label>
                <input
                  className={inp}
                  name="quotelt" type="text"
                  placeholder="e.g. 1 weeks"
                  value={quoteLt}
                  onChange={(e) => setQuoteLt(e.target.value)}
                />
              </div>
              <div>
                <label className={lbl}>Cxl</label>
                <input
                  className={inp}
                  name="quotecxl" type="text"
                  placeholder="e.g. NCNR"
                  value={quoteCxl}
                  onChange={(e) => setQuoteCxl(e.target.value)}
                />
              </div>
              <div>
                <label className={lbl}>Reschedule</label>
                <input
                  className={inp}
                  name="quoteresch" type="text"
                  placeholder="e.g. NCNR"
                  value={quoteResch}
                  onChange={(e) => setQuoteResch(e.target.value)}
                />
              </div>
              <div>
                <label className={lbl}>Delivery Terms</label>
                <input
                  className={inp}
                  name="quotedelterm" type="text"
                  placeholder="e.g. FOB BATAM"
                  value={quoteDelTerm}
                  onChange={(e) => setQuoteDelTerm(e.target.value)}
                />
              </div>
              <div>
                <label className={lbl}>Payment Terms</label>
                <input
                  className={inp}
                  name="quotepayterm" type="text"
                  placeholder="e.g. 30 Days"
                  value={quotePayTerm}
                  onChange={(e) => setQuotePayTerm(e.target.value)}
                />
              </div>
              <div>
                <label className={lbl}>Effective Type</label>
                <input
                  className={inp}
                  name="quoteefftype" type="text"
                  placeholder="e.g. PO BASED"
                  value={quoteEffType}
                  onChange={(e) => setQuoteEffType(e.target.value)}
                />
              </div>
              <div>
                <label className={lbl}>Expiration Date</label>
                <input
                  className={inp}
                  name="quoteexpdate" type="text"
                  placeholder="e.g. 3 months after..."
                  value={quoteExpDate}
                  onChange={(e) => setQuoteExpDate(e.target.value)}
                />
              </div>
              <div>
                <label className={lbl}>Country of Origin</label>
                <input
                  className={inp}
                  name="quoteorigin" type="text"
                  placeholder="e.g. Indonesia"
                  value={quoteOrigin}
                  onChange={(e) => setQuoteOrigin(e.target.value)}
                />
              </div>
            </div>
          </section>
        </div>

        {/* Footer */}
        <div className="flex-shrink-0 border-t border-gray-200 px-6 py-3 bg-gray-50 rounded-b-2xl flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="px-5 py-2 rounded-lg text-sm font-semibold text-gray-600 bg-white border border-gray-300 hover:bg-gray-100 transition"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-6 py-2 rounded-lg text-sm font-bold text-white bg-blue-600 hover:bg-blue-700 transition"
          >
            Update Quotation
          </button>
        </div>

        {isLoading && <LoadingOverlay message="Updating..." />}
        {showConfirm && uploadPending && (
          <ConfirmDialog
            message="Are you sure you want to update this quotation?"
            onConfirm={() => {
              setShowConfirm(false);
              updateQuotation();
            }}
            onCancel={() => {
              setShowConfirm(false);
              setUploadPending(false);
            }}
          />
        )}
      </form>
    </div>
  );
};

export default UpdateQuotationModal;
